// Func = limiting Scope for this file
let lastScrollTop = 0;
(function(){

	$(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// opentable click emulator ***

		// setTimeout(() => {
		// 	let openButtonOriginal = document.querySelector('.ot-dtp-picker-button');
		// 	let openButtonNav = document.querySelector('.open-btn-js');
		  
		// 	openButtonNav.addEventListener('click', () => {
		// 	  openButtonOriginal.click();
		// 	});
		// }, 1000);
		
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		// menu tabs controls *****

		let menuTabs = document.querySelectorAll('.js-menu-events-tab');
		

		menuTabs.forEach((button, index) => {
			
				
			button.addEventListener('mouseover', () => {
			let slidesToGo = button.dataset.link;
			$('.menus-tabs__slider').slick('slickGoTo', slidesToGo)
			});			
		});

		// filter tabs controls *****

		let filterTabs = document.querySelectorAll('.js-filter-tab');
		

		filterTabs.forEach((tab, index) => {
			if (index === 0) {
				tab.classList.add('active');
				}
			tab.addEventListener('click', () => {
			let slidesToGo = tab.dataset.link;
			$('.tabs-slider-content').slick('slickGoTo', slidesToGo);
			filterTabs.forEach((otherTab) => {
				if (otherTab !== tab) {
				  otherTab.classList.remove('active');
				}
			});
			if(tab.classList.contains('active')){
				tab.classList.remove('active');

			}else{
				tab.classList.add('active');
			}
			});
		});

		// to animate objects without animate-fade
		let elementAnimate = document.querySelectorAll('.elementAnimated');
		elementAnimate.forEach((elementA) => {
			elementA.classList.add('show');
		})
		const bookdirect = document.querySelector('.bookdirect');
		const btn_close = document.querySelector('#menu-js');
		bookdirect.addEventListener('click',() => {
			btn_close.click();
			console.log("esto funciona");
		} );

	});

	// Scroll Animations ----------------------------------------------------------------
	
	$(window).on('load', function(){
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
			
			let svgElement = document.querySelector('#svg_animated-js');
			// let previousElementClass = svgElement.previousElementSibling.classList[0];
			if (svgElement != null) {
			// checkElementVisibility(`.${previousElementClass}`,updownScroll);
			checkElementVisibility('#svg_animated-js' , function(element) {
				svgAnimation(element);
				// updownScroll(element);
			});

			}
		})
	});

	
	function checkElementVisibility(elementSelector, action) {
		let element = document.querySelector(elementSelector);
		let elementRect = element.getBoundingClientRect();
		let windowHeight = window.innerHeight || document.documentElement.clientHeight;
	  
		function handleVisibility() {
		  elementRect = element.getBoundingClientRect();
		  if (elementRect.top <= windowHeight && elementRect.bottom >= 0) {
			// Si el elemento es visible en el viewport
			if (!element.visible) {
			  action(element);
			  element.visible = true;
			}
		  } else {
			element.visible = false; 
		  }
		}
	  
		handleVisibility();
	  
		document.addEventListener("scroll", handleVisibility);
		window.addEventListener("resize", handleVisibility);
		
	}
	  
	function updownScroll(element) {
		let lastScrollTop = 0;
		let rotationAngle = 0;
		let rotate_img = document.querySelector("#svg_animated-js .small_img img");

	  
		function handleScroll(event) {
		  const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
		  const scrollDirection = currentScrollTop > lastScrollTop ? "down" : "up";
			// console.log("Scroll:", scrollDirection);
		  lastScrollTop = currentScrollTop;
	  
			if (scrollDirection === "up") {
				rotationAngle += 2;
			} else {
				rotationAngle -= 2;
			}

			if (rotate_img) {
				rotate_img .style.transform = `rotate(${rotationAngle}deg)`;
			}
		}
	  
		function handleWheel(event) {
		const wheelDirection = event.deltaY > 0 ? "up" : "down";
		//   console.log("Scroll:", wheelDirection);
		  if (wheelDirection === "down") {
			rotationAngle += 2; 
		  } else {
			rotationAngle -= 2; 
		  }

			if (rotate_img) {
				rotate_img .style.transform = `rotate(${rotationAngle}deg)`;
			}
		}
	  
		element.addEventListener("scroll", handleScroll);
		element.addEventListener("wheel", handleWheel);
	}
	  

	function svgAnimation(svgElement) {
		svgElement.style.setProperty('--after-animation', 'drawCircle 4s linear forwards');
	}




	// PARALLAX EFFECT *****************************************************/
	const scrollParallax = {};

	const v_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

	function doParallax(elm) {
	let bounds = elm.dataset.parallax.split(",").map(Number);
	let distance = bounds[1] - bounds[0];
	let unit_scroll = distance / (v_height + elm.offsetHeight);

	let topElement = elm.getBoundingClientRect().top + window.pageYOffset;

	let beforeSpeed = parseFloat(elm.dataset.parallaxSpeedBefore) || 1.0;
	let afterSpeed = parseFloat(elm.dataset.parallaxSpeedAfter) || 1.0;

	let parallaxFunction = function () {
		let scrolled = window.pageYOffset;
		let relative_distance = scrolled + v_height - topElement;
		let temp = unit_scroll * relative_distance + bounds[0];

		elm.style.transform = `translate(0, ${temp}px)`;
	};

	scrollParallax[elm.dataset.parallaxid] = parallaxFunction;

	window.addEventListener('scroll', scrollParallax[elm.dataset.parallaxid]);
	}

	let observers_parallax_elements = document.querySelectorAll(".js-parallax-element");
	observers_parallax_elements.forEach((elm) => {
	doParallax(elm);
	});

	const options_parallax = {
	root: null,
	rootMargin: '0px',
	threshold: 0,
	};

	function handler_parallax(entries) {
	entries.forEach((entry) => {
		const target = entry.target;
		const id_elem = target.dataset.parallaxid;

		if (entry.isIntersecting) {
		doParallax(target);
		} else {
		window.removeEventListener('scroll', scrollParallax[id_elem]);
		}
	});
	}

	const observable_parallax = new IntersectionObserver(handler_parallax, options_parallax);
	let counter = 1;

	observers_parallax_elements.forEach((element) => {
	observable_parallax.observe(element);
	element.dataset.parallaxid = counter;
	counter++;
	});

	/*****************************************************/

	// let aBtn = document.querySelectorAll(".btn_bg");
    // if(aBtn){
    //     aBtn.forEach(function(a_btn) {
    //         let htmlString = a_btn.innerText;
    //         a_btn.innerHTML = '<div class="circle-btn"></div><span class="text-btn">'+htmlString+'</span>';
    //         a_btn.addEventListener("mouseover", function(evt) {
    //             let mousePos = oMousePos(a_btn, evt);
    //             a_btn.querySelector('.circle-btn').style.top = mousePos.y+'px';
    //             a_btn.querySelector('.circle-btn').style.left = mousePos.x+'px';
    //         });
    //         a_btn.addEventListener("mouseout", function(evt) {
    //             let mousePos = oMousePos(a_btn, evt);
    //             a_btn.querySelector('.circle-btn').style.top = mousePos.y+'px';
    //             a_btn.querySelector('.circle-btn').style.left = mousePos.x+'px';
    //         });
    //     });
    // }

	let extraClassLinks= document.querySelectorAll('nav > ul > li > a');
		extraClassLinks.forEach((link) => {
		link.classList.add('navigation');
	});
	let extraClassImg= document.querySelectorAll('#gallerymontage a');
		extraClassImg.forEach((img) => {
		img.classList.add('image');
	});


	window.onload = function() { 
		if (document.querySelector("body#home")) {
			document.querySelector('.btn_bg.navigation').addEventListener('click', function(e) {
				e.preventDefault();
				let seccion = document.getElementById('intro-content-home');
				let posicion = seccion.offsetTop;
	
					if (window.scrollY !== posicion) {
						window.scrollTo({ top: posicion - 100, behavior: 'smooth' });
						localStorage.setItem('scrollPosition', posicion - 100);
					}
			});
		} else {
			let sectionId = location.hash.substring(1); 
			let section = document.getElementById(sectionId); 
				if (section) { 
					let storedPosition = localStorage.getItem('scrollPosition');
					if (storedPosition) {
						window.scrollTo({ top: storedPosition, behavior: 'smooth' });
					} else {
						window.scroll({ top: section.offsetTop - 100, behavior: 'smooth' });
					}
				}
		}
	};

}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if(document.getElementById('gallery') || document.querySelector('.sitemap') || document.querySelector('.terms-and-conditions')  && !document.getElementById('header').classList.contains('up')){
				
			document.getElementById('header').classList.add('up');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

	// Burger Menu  ****************************************************************
	let burgerMenu = document.getElementById('menu-js');
	burgerMenu.addEventListener('click', function () {
	let nav = document.getElementById("primary-nav");
	// let toggle = document.getElementById("menu-js");
	let menuTitle = document.getElementById('menu-title-js');
	let headerMenu = document.getElementById('header');
	if (!this.classList.contains('active')) {
		this.parentElement.classList.add('active');
		this.classList.add('active');
		nav.classList.add('active');
		// toggle.classList.add('active');
		headerMenu.classList.add('active');
		menuTitle.innerHTML = "Close";
	} else {
		this.classList.remove('active');
		this.parentElement.classList.remove('active');
		nav.classList.remove('active');
		// toggle.classList.remove('active');
		headerMenu.classList.remove('active');
		menuTitle.innerHTML = "Menu";
		}

	// Primary navigation animation ****************************************************************
	let navItems = document.querySelectorAll('#privary-navigation li a');
	let navItemsThird = document.querySelectorAll('.tertiary-navigation__list');

	function showNavItemWithDelay(navItem, delay) {
	setTimeout(function() {
		navItem.classList.add('show');
	}, delay);
	}
	setTimeout(() => {
		navItems.forEach(function(navItem, index) {
		let delay = index * 270; 
		showNavItemWithDelay(navItem, delay);
		});
	}, 270);


	
	setTimeout(() => {
		navItemsThird.forEach(function(navItem, index) {
		let delay = index * 500; 
		showNavItemWithDelay(navItem, delay);
		});
	}, 1700);

	});

